import $ from "jquery";
require("jquery-easing");
import Anchor from "./modules/Anchor";
import Scroll from "./modules/Scroll";
import SPMenu from "./modules/SPMenu";
import PCMenu from "./modules/PCMenu";
import ReadMore from "./modules/ReadMore";
import Form from "./modules/Form";
import Parallax from "./modules/Parallax";
import Top from "./modules/Top";
import { isNotPC } from "./modules/ua";


class App {
  init() {
    new Top().init();
    new Anchor().init();
    new Scroll().init();
    new PCMenu().init();
    new SPMenu().init();
    new ReadMore().init();
    new Form().init();
    new Parallax().init();

    if (isNotPC()) {
      const wh = $(window).height();
      $("#js-top").height(wh - 50);
      $("#js-menu-wrapper").height(wh - 50);
    }
  }
}

new App().init();



// WEBPACK FOOTER //
// ./src/js/app.js